function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_bii_127_1924)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 115,
  rx: 25,
  fill: "url(#paint0_linear_127_1924)",
  fillOpacity: 0.1
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.0589 31.0225C55.653 31.1982 54.3067 31.692 53.1338 32.4623C52.4817 32.8906 51.2889 34.0616 50.8527 34.7019C50.2308 35.6147 49.8072 36.5736 49.532 37.6918C49.4065 38.2017 49.39 38.5225 49.3627 40.9973L49.3324 43.7381H48.608C48.1759 43.7381 47.7231 43.7791 47.4858 43.8398C46.3185 44.1383 45.4195 45.0239 45.1138 46.1761C44.9621 46.7479 44.9621 61.99 45.1138 62.5618C45.4195 63.714 46.3185 64.5995 47.4858 64.898C47.8344 64.9872 49.135 64.9998 58.0064 64.9998C69.1467 64.9998 68.4907 65.0235 69.3168 64.5911C70.0941 64.1844 70.7635 63.2822 70.9308 62.4157C70.9754 62.1853 70.9999 59.3015 70.9999 54.3074C70.9999 45.8727 71.0146 46.2152 70.6204 45.4514C70.3787 44.983 69.7909 44.3948 69.3168 44.1467C68.7432 43.8465 68.2359 43.7381 67.4048 43.7381H66.6803L66.6501 40.9973C66.6227 38.5225 66.6063 38.2017 66.4807 37.6918C66.0611 35.987 65.3315 34.6991 64.1058 33.4996C62.849 32.2695 61.5353 31.5543 59.8336 31.1734C59.2686 31.0469 57.5927 30.9558 57.0589 31.0225ZM59.1585 33.9323C59.7956 34.0649 60.6134 34.3915 61.1131 34.7128C62.4283 35.5586 63.4083 36.9848 63.6854 38.4562C63.7296 38.6908 63.7587 39.8188 63.7587 41.2919V43.7381H58.0064H52.254L52.2552 41.2631C52.2565 38.5603 52.2793 38.3384 52.6523 37.3912C53.3309 35.6681 54.9269 34.3458 56.8221 33.9364C57.3611 33.82 58.6081 33.8178 59.1585 33.9323ZM58.9948 49.5941C59.9979 49.9605 60.6803 50.7852 60.8533 51.8401C61.0113 52.8031 60.5742 53.8569 59.7656 54.4623L59.4335 54.711L59.4136 56.5609L59.3937 58.4108L59.1877 58.6987C58.5323 59.6148 57.1216 59.4873 56.69 58.473C56.6044 58.2719 56.5852 57.9055 56.5852 56.4712V54.7154L56.2418 54.4592C55.444 53.8638 55.0021 52.7995 55.158 51.849C55.4039 50.3499 56.7428 49.3011 58.2432 49.4324C58.4666 49.4519 58.8047 49.5247 58.9948 49.5941Z",
  fill: "white",
  fillOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_bii_127_1924",
  x: -5.5,
  y: -5.5,
  width: 126,
  height: 126,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2.75
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_127_1924"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_127_1924",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_127_1924"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.75
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.541176 0 0 0 0 0.219608 0 0 0 0 0.956863 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_127_1924",
  result: "effect3_innerShadow_127_1924"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_127_1924",
  x1: 0,
  y1: 57.5,
  x2: 108.453,
  y2: 106.246,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7549AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D25A6"
})));

function SvgB1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/B1.1af27e8b.svg";
export { ForwardRef as ReactComponent };